import { render, staticRenderFns } from "./RecordatorioComponent.vue?vue&type=template&id=349cd990"
import script from "./RecordatorioComponent.vue?vue&type=script&lang=js"
export * from "./RecordatorioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports